import {h, Fragment} from "preact"
import { defaultConfig } from "../config"

export function SkeletonGrid(){
    return (
        <div class="grid grid--2-col grid--3-col-tablet grid--one-third-max grid--4-col-desktop grid--quarter-max negative-margin">
            {Array.from({ length: defaultConfig.serpSize }, (_, i) => (
                <div class='ns-skeleton-product ns-d-flex ns-flex-column'>
                    <div class='ns-skeleton-product-media' />
                    <div class='ns-skeleton-product-details ns-d-flex ns-flex-column' >
                        <div class='ns-skeleton-product-name' />
                        <div class='ns-skeleton-product-price' />
                    </div>
                </div>
            ))}
        </div>
    )
}

export function SkeletonHeader(){
    return (
        <div class="ns-d-flex ns-flex-column-reverse ns-flex-md-column">
            <div class="ns-skeleton-header" />
            <div class="ns-skeleton-toolbar ns-py-4">
                <div class="ns-skeleton-filters" />
                <div class="ns-skeleton-sort" />
            </div>
        </div>
    )
}